export const MEAL = '/meal'
export const MEAL_ADMIN = '/meal-admin'
